import flagDefault from '../assets/themes/icons/flag-icon.svg';
import flagUnitedStates from '../assets/themes/icons/flag-united-states-icon.svg';
import flagSpain from '../assets/themes/icons/flag-spain-icon.svg';
import flagFrance from '../assets/themes/icons/flag-france-icon.svg';
import flagItaly from '../assets/themes/icons/flag-italy-icon.svg';
import flagGermany from '../assets/themes/icons/flag-germany-icon.svg'

export function appLanguageList(): {code: string, label: string}[] {
  return [
    { code: 'french', label: 'Français' },
    { code: 'italian', label: 'Italiano' },
    { code: 'german', label: 'Deutsch' },
    { code: 'english', label: 'English' },
    { code: 'spanish', label: 'Español' }
  ]
}

export function appLanguageLabel(code: string): string {
  return appLanguageList().find((item) => (item.code === code))?.label ?? 'English'
}

export function appLanguageIcon(code: string): string {
  switch (code) {
    case 'english':
      return flagUnitedStates
    case 'spanish':
      return flagSpain
    case 'french':
      return flagFrance
    case 'italian':
      return flagItaly
    case 'german':
      return flagGermany
    default:
      return flagDefault
  }
}

export function appLanguageStorage(): string {
  let idiom: string = localStorage.getItem('language') || 'english'

  if (!localStorage.getItem('language')) {
    localStorage.setItem('language', idiom)
  }

  return idiom
}

export function appLanguageLocale(): string {
  let locale: Record<string, string> = { english: 'en', spanish: 'es', french: 'fr', italian: 'it', german: 'de' }
  let idiom: string = localStorage.getItem('language') || 'english'

  return locale[idiom]
}

export function appLanguageRouteIsValid(param_language: any): boolean {
  return !param_language || ['en', 'es', 'fr', 'it', 'de'].includes(param_language)
}

export function appLanguageRouteUpload(dispatch_language: any, param_language: any) {
  let language: Record<string, string> = { en: 'english', es: 'spanish', fr: 'french', it: 'italian', de: 'german' }
  let idiom: string = (param_language && language[param_language]) ? language[param_language] : (localStorage.getItem('language') || 'english')

  localStorage.setItem('language', idiom)
  dispatch_language({type: idiom})
}
